'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'hexagon-vertical-nft-slanted';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e506';
var svgPathData = 'M255.8 496.6c-19.8 11.4-44.2 11.4-64 0L32 404.3C12.2 392.9 0 371.7 0 348.9V164.3c0-22.9 12.2-44 32-55.4L191.8 16.6c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4V348.9c0 22.9-12.2 44-32 55.4L255.8 496.6zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7V164.3c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7l0 184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM272 123.5c0 12.3-13.3 20-23.9 13.9l-24.2-13.8v117h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v128c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144V96.3c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6l.1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3c5 2.8 8.1 8.2 8.1 13.9zm16 27.4c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3V352.6c0 8.8-7.2 16-16 16s-16-7.2-16-16V178.4l-23.8-13.6c-5-2.8-8.1-8.2-8.1-13.9zM143.8 128.6c8.8 0 16 7.2 16 16v224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2v61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270V144.6c0-8.8 7.2-16 16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHexagonVerticalNftSlanted = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;